import { stageBgClass } from "./chartPalette";

/**
 * A stage as a pill: the palette's dot, the name. `Rejected` keeps the grey the
 * palette already gives the neutral stages; the pill's border is what reads as
 * "a status", so the dot never has to carry the meaning alone.
 */
export function StagePill({ stage }: { stage: string | null | undefined }) {
  if (!stage) return <span className="text-text-muted">—</span>;
  return (
    <span
      data-testid="candidate-stage-pill"
      data-stage={stage}
      className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-border px-2 py-0.5 text-label text-text"
    >
      <span aria-hidden="true" className={`h-2 w-2 shrink-0 rounded-full ${stageBgClass(stage)}`} />
      {stage}
    </span>
  );
}
